export default __webpack_public_path__ + "img/a3c6c3445ee86223488cb303280502f6.png";